import React from 'react';

import _ from 'lodash';

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputRadioGroupField from '../../Fields/InputRadioGroupField';
import InputSelectField from '../../Fields/InputSelectField';
import FeeTable from '../../Fields/FeeTable';


class RateDetailBillingPanel extends React.Component {
  _onFeeChange(type) {
    return (ident, value) => {
      const fees = _.cloneDeep(this.props.rate.fields.fees);

      if (ident === null) ident = fees[type].value.length;

      fees[type].value[ident] = value;

      this._onInputChange('fees')(fees);
    };
  }


  _onInputChange(inputId) {
    return value => {
      switch (inputId) {
        case 'tax_exempt':
          if (value !== null) value = (value === 'true') ? true : false;
          break;
        case 'first_month_proration_day':
          if (value !== null) value = parseInt(value, 10);
          break;
        default:
      }

      this.props.onValueChange(inputId, value);
    };
  }


  render() {
    const {
      rate,
      newMode,
      editMode,
      fieldConfiguration,
      billingProfiles
    } = this.props;

    const {
      rate: rateFieldConfiguration
    } = fieldConfiguration;

    const inputBillingProfileOptions = [];
    billingProfiles.forEach(billingProfile => {
      if (!newMode || (newMode && billingProfile.fields.active.value === true)) {
        inputBillingProfileOptions.push({
          value: billingProfile.fields.id.value,
          label: billingProfile.fields.name.value
        });
      }
    });

    const selectedBillingProfile = billingProfiles.find(billingProfile => {
      return billingProfile.fields.id.value === rate.fields.billing_profile_id.value;
    });

    const renderFirstMonthProrationFields = selectedBillingProfile;

    const monthlyFeeTableRows = rate.fields.fees.monthly.value.map((fee, index) => {
      return { ident: index, data: fee };
    });

    const disabledMonthlyFeeInputFields = (rate.fields.tax_exempt.value === true) ?
      { tax_1: true, tax_2: true, tax_3: true, tax_4: true } : {};

    const requiredFieldState = (newMode || editMode);

    return (
      <div>
        <FieldGroup label="Billing Rules">
          <Field label="Billing Profile"
            id="parkchirp--rate--billing-profile-id"
            required={requiredFieldState}
            layout="columns">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <InputSelectField inputId="parkchirp--rate--billing-profile-id"
                value={rate.fields.billing_profile_id.value}
                options={[{ value: null, label: '' }, ...inputBillingProfileOptions]}
                onChange={this._onInputChange('billing_profile_id')}
                editMode={newMode || editMode}
              />
              {(selectedBillingProfile !== undefined && selectedBillingProfile.fields.facility.value !== null) &&
                <span style={{ marginLeft: '1em', fontStyle: 'italic' }}>
                  ({selectedBillingProfile.fields.facility.value.fields.facility_name.value})
                </span>
              }
            </div>
          </Field>
          {(renderFirstMonthProrationFields) &&
            <Field label="First Month Proration"
              id="parkchirp--rate--first-month-proration"
              required={requiredFieldState}
              layout="columns">
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <InputSelectField inputId="parkchirp--rate--first-month-proration"
                  value={rate.fields.first_month_proration.value}
                  options={[{ value: null, label: '' }, ...rateFieldConfiguration.first_month_proration.options]}
                  onChange={this._onInputChange('first_month_proration')}
                  editMode={newMode || editMode}
                />
                {(rate.fields.first_month_proration.value === 'HALF_MONTH') &&
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: '0.3rem' }}>
                    <span style={{ marginRight: '0.3em' }}>on or after the</span>
                    <InputSelectField inputId="parkchirp--rate--first-month-proration-day"
                      value={rate.fields.first_month_proration_day.value}
                      options={[{ value: null, label: '' }, ...rateFieldConfiguration.first_month_proration_day.options]}
                      onChange={this._onInputChange('first_month_proration_day')}
                      editMode={newMode || editMode}
                    />
                    <span style={{ marginLeft: '0.3em' }}>day of the month</span>
                  </div>
                }
              </div>
            </Field>
          }
        </FieldGroup>
        <FieldGroup label="Billing Rates">
          <Field label="Tax Exempt Rate"
            id="parkchirp--rate--tax-exempt"
            required={requiredFieldState}
            layout="columns">
            <InputRadioGroupField inputId="parkchirp--rate--tax-exempt"
              options={rateFieldConfiguration.tax_exempt.options}
              value={rate.fields.tax_exempt.value}
              onChange={this._onInputChange('tax_exempt')}
              editMode={newMode || editMode}
            />
          </Field>
          <Field layout="stacked">
            <FeeTable inputId="parkchirp--rate--monthly-fee"
              feeRows={monthlyFeeTableRows}
              entityLabel="Rate"
              feeType="MONTHLY"
              onFeeChange={this._onFeeChange('monthly')}
              allowAdd={(newMode || editMode)}
              editMode={(newMode || editMode)}
              disabledMode={disabledMonthlyFeeInputFields}
            />
          </Field>
        </FieldGroup>
      </div>
    );
  }
}
export default RateDetailBillingPanel;
